import React from 'react';
import { Button } from 'tamagui';
import { useTheme } from 'tamagui';
import { DSColor } from '../types';

interface CobuBackButtonProps {
  onPress: () => void;
  color?: DSColor | string;
  size?: number;
}

const HIT_SLOP = { top: 8, right: 8, bottom: 8, left: 8 } as const;

const CobuBackButton: React.FC<CobuBackButtonProps> = ({
  onPress,
  color = '$cobuTopaz',
  size = 24,
}) => {
  const theme = useTheme();

  const resolveColor = (token?: DSColor | string): string | undefined => {
    if (!token) return undefined;
    if (typeof token === 'string' && token.startsWith('$')) {
      const key = token.slice(1);
      return (theme as any)[key]?.val ?? undefined;
    }
    return token as string;
  };


  return (
    <Button
      hitSlop={HIT_SLOP}
      onPress={onPress}
      backgroundColor="transparent"
      borderColor="transparent"
      borderWidth={0}
      hoverStyle={{ backgroundColor: 'transparent', borderColor: 'transparent' }}
      pressStyle={{ backgroundColor: 'transparent', borderColor: 'transparent' }}
      focusStyle={{ backgroundColor: 'transparent', borderColor: 'transparent' }}
      px="$0"
      py="$0"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 1024 1024"
        aria-hidden="true"
        focusable="false"
        style={{ display: 'block', color: color || '$CobuTopaz' }}
      >
        <path fill="currentColor" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z" />
        <path fill="currentColor" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z" />
      </svg>
    </Button>
  );
};

export default CobuBackButton;
